<script setup>
  const { event } = defineProps({ event: Object, small: Boolean, tiny: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <img :src="event.event_logo?.url" :alt="event.event_logo?.alt" width="320" height="60" :class="{ small, tiny }" />
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  img {
    width: px(320);
    height: auto;

    user-select: none;

    &.small {
      width: px(256);
    }

    &.tiny {
      width: px(208);
    }

    @include break-medium {
      width: px(230);
      &.small {
        width: px(230);
      }
    }

    @include break-small {
      width: px(200);
      &.small {
        width: px(200);
      }

      &.tiny {
        width: px(192);
      }
    }

    @include break-phone {
      &.tiny {
        width: px(170);
      }
    }
  }
</style>
